// Qual lista abre ao clicar numa barra do gráfico do Painel Comercial
// (06/10/2026). Antes abria sempre as VENDAS do mês, qualquer que fosse a
// variável — com "Propostas" selecionado, o Lucas via vendas no lugar das
// propostas que fez. O servidor (`/comercial/dashboard/vendas?tipo=`) usa a
// mesma régua da barra; aqui só se escolhe o tipo e o texto.
export type TipoDetalhe = 'vendas' | 'propostas' | 'fechados';

/** A variável do gráfico decide a lista. Variável desconhecida = vendas (o de sempre). */
export function tipoDoDetalhe(variavel: string): TipoDetalhe {
  if (variavel === 'propostas_criadas' || variavel === 'valor_proposto') return 'propostas';
  if (variavel === 'negocios_fechados' || variavel === 'taxa_conversao_pct') return 'fechados';
  return 'vendas';
}

export function tituloDetalhe(tipo: TipoDetalhe, periodo: string): string {
  if (tipo === 'propostas') return `Propostas criadas em ${periodo}`;
  if (tipo === 'fechados') return `Negócios fechados em ${periodo}`;
  return `Vendas de ${periodo}`;
}

export const TEXTO_VAZIO: Record<TipoDetalhe, string> = {
  vendas: 'Nenhuma venda ganha neste período',
  propostas: 'Nenhuma proposta criada neste período',
  fechados: 'Nenhum negócio ganho ou perdido neste período',
};

export const DICA_CLIQUE: Record<TipoDetalhe, string> = {
  vendas: 'Clique para ver as vendas',
  propostas: 'Clique para ver as propostas criadas',
  fechados: 'Clique para ver os negócios ganhos e perdidos',
};
